"use client";

import React, { FC, PropsWithChildren } from "react";
import {
  GlobalStateProvider,
  ShaApplicationProvider,
  StoredFilesProvider,
  useNextRouter,
  SignalRProvider
} from "@shesha-io/reactjs";
import { AppProgressBar } from "next-nprogress-bar";
import { useTheme } from "antd-style";
import { EnterpriseApplicationPlugin } from "@shesha-io/enterprise";
import { DepApplicationPlugin } from "@shesha-io/dep";
import { ServiceAutoApplicationPlugin } from "@shesha-io/serviceautomation";
import { ChatApplicationPlugin } from "@shesha-io/chat-service";
import { DevExpressReportingApplicationPlugin, GlobalDevExpressStyles } from "@shesha-io/devexpressreporting";

import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import { CustomConfigurableActionsAccessor } from "@/components/configurable-actions/custom-configurable-actions-processor";
import { RslApplicationPlugin } from "./providers/rslApplicationPlugin";

export interface IAppProviderProps {
  backendUrl: string;
}

export const AppProvider: FC<PropsWithChildren<IAppProviderProps>> = ({
  children,
  backendUrl,
}) => {
  const nextRouter = useNextRouter();
  const theme = useTheme();

  const onConnected = () => {
    console.log('Signal R connected');
  };

  const onDisconectedConnected = () => {
    console.log('Signal R diconnected');
  };


  return (
    <MsalProvider instance={new PublicClientApplication(msalConfig)}>
      <GlobalStateProvider>
        <GlobalDevExpressStyles />
        <AppProgressBar height="4px" color={theme.colorPrimary} shallowRouting />
        <ShaApplicationProvider
          backendUrl={backendUrl}
          router={nextRouter}
          noAuth={nextRouter.path?.includes('/no-auth') || nextRouter.path?.includes('/account/')}
        >
          <CustomConfigurableActionsAccessor>
            <DevExpressReportingApplicationPlugin>
              <SignalRProvider hubUrl="/signalr-client" onConnected={onConnected} onDisconnected={onDisconectedConnected}>
                <EnterpriseApplicationPlugin>
                  <DepApplicationPlugin>
                    <ServiceAutoApplicationPlugin>
                      <RslApplicationPlugin>
                        <ChatApplicationPlugin>
                          <StoredFilesProvider baseUrl={backendUrl} ownerId={""} ownerType={""}>
                            {children}
                          </StoredFilesProvider>
                        </ChatApplicationPlugin>
                      </RslApplicationPlugin>
                    </ServiceAutoApplicationPlugin>
                  </DepApplicationPlugin>
                </EnterpriseApplicationPlugin>
              </SignalRProvider>
            </DevExpressReportingApplicationPlugin>
          </CustomConfigurableActionsAccessor>
        </ShaApplicationProvider>
      </GlobalStateProvider>
    </MsalProvider>
  );
};
